export const selectChoice = (dispatch, questionId, questionStemId, choiceId) =>
  dispatch({
    type: "CHOICE_SELECTED",
    questionId,
    questionStemId,
    choiceId,
  });

export const toggleDiscardChoice = (values, dispatch) => {
  const { isDiscarted, ...rest } = values;

  return dispatch({
    type: isDiscarted ? "UNDISCARD_CHOICE" : "DISCARD_CHOICE",
    ...rest,
  });
};
